export default {
  hero: {
    title: 'AllChinaBuy Spreadsheet — Produkte, Verkäufer & Kaufressourcen finden',
    subtitle: 'Erkunden Sie die AllChinaBuy-Tabelle, Produktressourcen, Verkäuferleitfäden, QC-Informationen, Versandleitfäden und praktische Kauftipps an einem Ort. Recherchieren Sie intelligenter, bevor Sie bestellen.',
    ctaMain: 'AllChinaBuy-Tabelle erkunden',
    ctaSecondary: 'Anfängerleitfaden starten',
    ctaAllChinaBuy: 'AllChinaBuy-Tabelle',
    ctaBuyNow: 'Jetzt kaufen',
  },
  categories: {
    title: 'Beliebte Kategorien',
    subtitle: 'Durchsuchen Sie Produktkategorien und finden Sie genau, wonach Sie suchen',
  },
  articles: {
    title: 'Neueste Leitfäden & Ressourcen',
    subtitle: 'Originalforschung, Kauftipps und praktische Leitfäden, die Ihnen helfen, intelligenter einzukaufen',
  },
  features: {
    title: 'Warum AllChinaBuy-Tabelle verwenden?',
    item1: 'Organisierte Produktlinks von vertrauenswürdigen Verkäufern',
    item2: 'QC-Fotos und Qualitätsverifizierungstipps',
    item3: 'Versandkostenschätzungen und Methodenvergleiche',
    item4: 'Aktive Gutschein- und Rabattcode-Updates',
  },
  seo: {
    title: 'AllChinaBuy Spreadsheet 2026 — Produkte, Verkäufer, QC & Versand',
    description: 'Erkunden Sie die AllChinaBuy-Tabelle, Produktressourcen, Verkäuferleitfäden, QC-Informationen und Versandleitfäden an einem Ort.',
    keywords: 'AllChinaBuy, Tabelle, Kaufanleitung, Versand, QC, Gutschein, Rabatt',
  },
};